/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTableTranspose: {
  name: 'table-transpose';
  data: string;
} = {
  name: 'table-transpose',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm4 0h-2v9h2V5ZM3 19a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2Zm11 0H5v2h9v-2Zm-.793-15.207a1 1 0 1 0-1.414 1.414l.052.053a9.015 9.015 0 0 0-6.585 6.585l-.053-.052a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.154.187l2-1a1 1 0 1 0-.894-1.788l-.339.169a7.012 7.012 0 0 1 5.06-5.06l-.168.338a1 1 0 1 0 1.788.894l1-2a1 1 0 0 0-.187-1.154l-1.5-1.5Z" fill="currentColor"/></svg>`,
};
